export default function ({ app: { $routeResolver }, store, redirect, route }) {
  const userData = !process.server ? store.getters['user/getValidLogin'] : null

  if (!userData) {
    redirect($routeResolver('routes.customer.login', store.getters.getLocale, true, {}, { 'redirect': route.fullPath }))
  }
}
